export const LOAD_PORTFOLIO = 'LOAD_PORTFOLIO';